module.exports = __webpack_public_path__ + "img/logo-facebook.16c690f1.svg";